@if (accountService.user) {
	<li class="nav-item dropdown no-caret me-3 me-lg-0 dropdown-user" ngbDropdown [placement]="placement" display="dynamic">
		<a
			class="btn btn-icon btn-transparent-dark dropdown-toggle"
			id="navbarDropdownUserImage"
			ngbDropdownToggle
			data-cy="userMenu"
			role="button"
			aria-haspopup="true"
			aria-expanded="false">
			@if (accountService.user$ | async; as user) {
				<span class="navbar-user-initials">{{ userInitials(user?.name) }}</span>
			}
		</a>
		<div class="dropdown-menu border-0 shadow animated--fade-in-up" ngbDropdownMenu aria-labelledby="dropdownUser">
			<h6 class="dropdown-header d-flex align-items-center">
				@if (accountService.user$ | async; as user) {
					<div class="dropdown-user-details">
						<div class="dropdown-user-details-name">
							{{ user.name }}
						</div>
						<div class="dropdown-user-details-email">{{ user.email }}</div>
					</div>
				}
			</h6>
			<div class="dropdown-divider"></div>
			@if (profileEditable) {
				<!-- No app, Minha Conta é uma aba do menu inferior (spec 058). -->
				@if (!platform.mobile) {
					<a class="dropdown-item" [routerLink]="accountLink">
						<div class="dropdown-item-icon">
							<i-feather name="settings"></i-feather>
						</div>
						Minha Conta
					</a>
				}
				@if (hasDualRole && !platform.mobile) {
					<a class="dropdown-item" (click)="goRoleSelect()">
						<div class="dropdown-item-icon">
							<i-feather name="user-check"></i-feather>
						</div>
						Trocar Perfil
					</a>
				}
				@if (showVisitorActivation) {
					<a class="dropdown-item" (click)="goVisitorActivation()">
						<div class="dropdown-item-icon">
							<i-feather name="eye"></i-feather>
						</div>
						Ativar perfil de visitante
					</a>
				}
			} @else {
				@if (accountService.isSupplier) {
					<a class="dropdown-item" routerLink="/supplier/board" (click)="changeToSupplier()">
						<div class="dropdown-item-icon">
							<i-feather name="shuffle"></i-feather>
						</div>
						Conta de Fornecedor
					</a>
				}
				@if (accountService.isSinger) {
					<a class="dropdown-item" routerLink="/signer/board" (click)="changeToSigner()">
						<div class="dropdown-item-icon">
							<i-feather name="shuffle"></i-feather>
						</div>
						Conta de Signatário
					</a>
				}
				@if (accountService.isVisitor) {
					<a class="dropdown-item" routerLink="/visitor/board" (click)="changeToVisitor()">
						<div class="dropdown-item-icon">
							<i-feather name="shuffle"></i-feather>
						</div>
						Conta de Visitante
					</a>
				}
				@if (showVisitorActivation) {
					<a class="dropdown-item" (click)="goVisitorActivation()">
						<div class="dropdown-item-icon">
							<i-feather name="eye"></i-feather>
						</div>
						Ativar perfil de visitante
					</a>
				}
			}
			<button class="dropdown-item" (click)="authService.logout()" [disabled]="authService.logoutSubmitted">
				<div class="dropdown-item-icon">
					<i-feather name="log-out"></i-feather>
				</div>
				<app-label-loading-dots [loading]="authService.logoutSubmitted" label="Sair"></app-label-loading-dots>
			</button>
			@if (platform.mobile) {
				<div class="dropdown-divider"></div>
				<div class="dropdown-item-text dropdown-user-version small text-center">Versão {{ version }}</div>
			}
		</div>
	</li>
}
